module.exports = __webpack_public_path__ + "static/media/avatar.37c8dfc2.webp";